module.exports = __webpack_public_path__ + "static/media/orders.5f0e172c.jpg";